import { Col, InputNumber, InputNumberProps, Row, Select, Slider, Switch, Typography } from 'antd';
import { Paper } from '../../../components/common/common';
import { saveSelectedPortForRunnerPush } from '../../../services/cache/localStorage';

export interface PumpPowerSettings {
  setOnDevice: boolean;
  value: number;
}

type GlobalParametersComponentProps = {
  showGlobalParameters: boolean;
  pumpPower: PumpPowerSettings;
  setPumpPower: React.Dispatch<React.SetStateAction<PumpPowerSettings>>;
  isGraphQlPushRunning: boolean;
  setIsGraphQlPushRunning: React.Dispatch<React.SetStateAction<boolean>>;
  targetPort: number;
  setTargetPort: React.Dispatch<React.SetStateAction<number>>;
  isAutoSavedMeasurementEnabled: boolean;
  setIsAutoSavedMeasurementEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  samplingFrequency: number;
  setSamplingFrequency: React.Dispatch<React.SetStateAction<number>>;
};

const GlobalParametersComponentWithAdjustablePort: React.FC<GlobalParametersComponentProps> = ({
  showGlobalParameters,
  pumpPower,
  setPumpPower,
  isGraphQlPushRunning,
  setIsGraphQlPushRunning,
  targetPort,
  setTargetPort,
  isAutoSavedMeasurementEnabled,
  setIsAutoSavedMeasurementEnabled,
  samplingFrequency,
  setSamplingFrequency,
}) => {
  const onPumpPowerSliderChange: InputNumberProps['onChange'] = (newValue) => {
    if (newValue === null) return;
    let x = newValue as number;
    setPumpPower({ setOnDevice: true, value: x });
  };

  const toggleSwitch = (checked: boolean) => {
    setIsGraphQlPushRunning(checked);
  };

  const handlePortChange = (value: number) => {
    setTargetPort(value);
    saveSelectedPortForRunnerPush(value);
  };

  return (
    <>
      {showGlobalParameters && (
        <Paper style={{ width: '100%', height: '100%', marginTop: 50, marginBottom: 30 }}>
          <Typography.Title level={5} style={{ margin: 'auto', textAlign: 'center', width: '100%', marginBottom: 30 }}>
            Global parameters
          </Typography.Title>

          <Row justify="center">
            <Col span={24}>
              <Typography.Text>Auto-save measurement to cloud database</Typography.Text>
              <div style={{ marginTop: 8 }}>
                <Switch checked={isAutoSavedMeasurementEnabled} onChange={setIsAutoSavedMeasurementEnabled}></Switch>
              </div>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: 30 }}>
            <Col span={24}>
              Pump power (mW)
              <Row style={{ marginTop: 5, width: '100%' }}>
                <Col span={16}>
                  <Slider min={0} max={1000} onChange={onPumpPowerSliderChange} value={pumpPower.value} />
                </Col>
                <Col span={8}>
                  <InputNumber min={0} max={1000} style={{ margin: '0 16px' }} value={pumpPower.value} onChange={onPumpPowerSliderChange} />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: 30 }}>
            <Col span={24}>
              Set frequency (Hz)
              <div style={{ marginTop: 8 }}>
                <Select
                  value={samplingFrequency}
                  placeholder={'Set frequency (Hz)'}
                  options={[{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }, { value: 6 }, { value: 10 }, { value: 12 }, { value: 15 }, { value: 20 }, { value: 30 }, { value: 60 }]}
                  onChange={setSamplingFrequency}
                />
              </div>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: 30 }}>
            <Col span={24}>
              GraphQL push
              <Col span={24} style={{ marginTop: 10 }}>
                <Switch checked={isGraphQlPushRunning} onChange={toggleSwitch} />
              </Col>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: 30 }}>
            <Col span={24}>
              Target URL Port
              <Col span={24} style={{ marginTop: 10 }}>
                <Select
                  value={targetPort}
                  onChange={handlePortChange}
                  style={{ width: 200 }}
                  options={[
                    { value: 4000, label: '4000' },
                    { value: 4002, label: '4002' },
                    { value: 4006, label: '4006' },
                  ]}
                />
              </Col>
            </Col>
          </Row>
        </Paper>
      )}
    </>
  );
};

export default GlobalParametersComponentWithAdjustablePort;
